module.exports = __webpack_public_path__ + "media/dashboard/assets/icons/eye-slash-icon-0f55dfe43ee56b0d893ea467b112ceca.svg";